<template>
  <section>
    <!--工具条-->
    <toolbar
      placeholder="请输入名称"
      :buttonList="buttonList"
      @callFunction="callFunction"
    ></toolbar>

    <!--列表-->
    <el-table
      :data="dataList"
      v-loading="listLoading"
      highlight-current-row
      style="width: 100%"
      ref="table"
      @select="dialogCheck"
      @row-click="selectCurrentRow"
      class="custom-tbl"
    >
      <el-table-column type="selection" min-width="10"> </el-table-column>
      <el-table-column type="index" label="序号" min-width="10"> </el-table-column>
      <el-table-column prop="logo" label="logo" min-width="10">
        <template slot-scope="scope">
          <el-avatar
            v-if="scope.row.logo"
            :src="scope.row.logo.url"
          ></el-avatar>
        </template>
      </el-table-column>
      <el-table-column
        prop="sportsName"
        label="运动名称"
        min-width="20"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="sportsClass"
        label="运动样式"
        show-overflow-tooltip
        min-width="10"
      ></el-table-column>
      <el-table-column
        prop="isDisable"
        label="状态"
        min-width="10"
        show-overflow-tooltip
        sortable
      >
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.isDisable ? 'danger' : 'success'"
            disable-transitions
            >{{ scope.row.isDisable ? "停用" : "正常" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="10">
        <template slot-scope="scope">
          <el-button
            v-if="!scope.row.isDisable"
            size="small"
            @click="handleDisable(scope.row)"
            >停用</el-button
          >
          <el-button
            v-if="scope.row.isDisable"
            size="small"
            @click="handleEnable(scope.row)"
            >启用</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageModel.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageModel.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageModel.dataCount"
        style="float:right;"
      >
      </el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="100px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="运动名称" prop="sportsName">
              <el-input
                v-model="editForm.sportsName"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否停用" prop="isDisable">
              <el-switch v-model="editForm.isDisable"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="运动简介" prop="description">
              <el-input
                v-model="editForm.description"
                auto-complete="off"
                type="textarea"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="图标样式" prop="sportsClass">
              <el-input
                v-model="editForm.sportsClass"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="logo上传" prop="logo">
              <ImageFile
                tips="推荐尺寸1:1,大小不超过50KB"
                :value="logoImageList"
                :limiCount="1"
                :limitSize="50"
                @change="logoChange"
              ></ImageFile>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="100px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="运动名称" prop="sportsName">
              <el-input
                v-model="addForm.sportsName"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否停用" prop="isDisable">
              <el-switch v-model="addForm.isDisable"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="运动简介" prop="description">
              <el-input
                v-model="addForm.description"
                auto-complete="off"
                type="textarea"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="图标样式" prop="sportsClass">
              <el-input
                v-model="addForm.sportsClass"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="logo上传" prop="logo">
              <ImageFile
                tips="推荐尺寸1:1,大小不超过50KB"
                :value="logoImageList"
                :limiCount="1"
                :limitSize="50"
                @change="logoChange"
              ></ImageFile>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  querySportsListPage,
  removeSports,
  saveSports,
  disableSports,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import ImageFile from "../../components/ImageFile";

export default {
  components: { Toolbar, ImageFile },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      filter: {
        key: "",
        page: 1,
        pageSize: 10,
      },
      dataList: [],
      pageModel: {
        pageSize: 10,
        dataCount: 0,
        page: 1,
        pageCount: 0,
      },
      listLoading: false,
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        sportsName: [
          { required: true, message: "请输入运动名称", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "名称长度在2到20个字符",
            trigger: "blur",
          },
        ],
        isDisable: [
          { required: true, message: "请选择是否停用", trigger: "change" },
        ],
        description: [
          {
            max: 200,
            message: "简介长度不能超过200个字符",
            trigger: "blur",
          },
        ],
      },
      //编辑界面数据
      editForm: {
        id: "",
        sportsName: "",
        description: "",
        isDisable: false,
      },
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        sportsName: [
          { required: true, message: "请输入名称", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "名称长度在2到20个字符",
            trigger: "blur",
          },
        ],
        isDisable: [
          { required: true, message: "请选择是否停用", trigger: "change" },
        ],
        description: [
          {
            max: 200,
            message: "简介长度不能超过200个字符",
            trigger: "blur",
          },
        ],
      },
      //新增界面数据
      addForm: {
        sportsName: "",
        description: "",
        isDisable: false,
      },
      logoImageList: [],
    };
  },
  methods: {
    logoChange() {},
    handleSizeChange(val) {
      this.filter.page = 1;
      this.filter.pageSize = val;
      this.handleQuery();
    },
    handleCurrentChange(val) {
      this.filter.page = val;
      this.handleQuery();
    },
    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      this.filter.key = item.search;
      this[item.func].apply(this, item);
    },
    //停用
    handleDisable(row) {
      if (!row) return;
      this.$confirm("确认停用该运动项吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: row.id, isDisable: true };
          disableSports(para).then((res) => {
            this.listLoading = false;
            if (res.data.isSuccess) {
              this.$message({
                message: "已停用",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            this.handleQuery();
          });
        })
        .catch(() => {});
    },
    //启用
    handleEnable(row) {
      if (!row) return;
      this.$confirm("确认启用该运动项吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: row.id, isDisable: false };
          disableFacility(para).then((res) => {
            this.listLoading = false;
            if (res.data.isSuccess) {
              this.$message({
                message: "已启用",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            this.handleQuery();
          });
        })
        .catch(() => {});
    },
    //获取用户列表
    handleQuery() {
      this.listLoading = true;

      //NProgress.start();
      querySportsListPage(this.filter).then((res) => {
        this.pageModel = res.data.response;
        this.dataList = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.id };
          removeSports(para).then((res) => {
            this.listLoading = false;
            //NProgress.done();
            if (res.data.isSuccess) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit() {
      this.logoImageList = [];
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      if (row.logo) {
        this.logoImageList.push(row.logo);
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        sportsName: "",
        description: "",
        isDisable: false,
      };
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            let formData = new FormData();
            formData.append("model", JSON.stringify(this.editForm));
            let logos = this.logoImageList.filter((s) => s.status == "ready");
            if (logos.length > 0) {
              formData.append("logoImage", logos[0].raw);
            }
            saveSports(formData).then((res) => {
              this.editLoading = false;
              if (res.data.isSuccess) {
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.logoImageList = [];
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let formData = new FormData();
            formData.append("model", JSON.stringify(this.addForm));
            let logos = this.logoImageList.filter((s) => s.status == "ready");
            if (logos.length > 0) {
              formData.append("logoImage", logos[0].raw);
            }
            saveSports(formData).then((res) => {
              this.addLoading = false;
              if (res.data.isSuccess) {
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.logoImageList = [];
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
  },
  mounted() {
    this.handleQuery();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
</style>
